import React from "react";

const TaxIcon = (props) => {
  const height = props?.height || 20;
  const width = props?.width || 20;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M7 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8l-6-6H7zm5 1.5L18.5 9H12V3.5zM9 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm6 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-7.2 1.4 7.8-7.8.9.9-7.8 7.8-.9-.9z"
      />
    </svg>
  );
};

export default TaxIcon;
